import { Component } from '@angular/core';

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
    standalone: false
})
export class UploadComponent {
  uploadedFiles: File[] = [];

  onFileSelected(event: any) {
    for (let i = 0; i < event.target.files.length; i++) {
      this.uploadedFiles.push(event.target.files[i]);
    }
  }
}
